<template>

  <div class="height-100">
    <div
      ref="iframe"
      class="height-100"
      style="overflow: hidden;"></div>
  </div>

</template>

<script>
import axios from 'axios'
import config from '../../config'
import cookie from 'js-cookie'
const axiosInstance = axios.create({
  baseURL: config.api_url,
  json: true
})

export default {
  name: 'Meet',
  components: {
  },
  data () {
    return {
      api: null
    }
  },
  computed: {
    token () {
      return this.$route.params.token
    }
  },
  mounted () {
    this.getContext().then(res => {
      const {
        candidateId,
        jobId,
        accountId
      } = res

      this.$router.push(`/job/${jobId}?candidate_id=${candidateId}&candidate_job_id=${jobId}&account_id=${accountId}&meet_token=${this.token}`)
    }).catch(() => {
      this.startJitsi()
    })
  },
  methods: {
    startJitsi () {
      this.api = new window.JitsiMeetExternalAPI('8x8.vc', {
        roomName: `vpaas-magic-cookie-9fef128db54248398f7d405cb10e501b/${this.token}`,
        // parentNode: document.querySelector('#jaas-container'),
        parentNode: this.$refs.iframe,
        configOverwrite: {
          enableNoisyMicDetection: false,
          subject: 'Reunião'
        },
        interfaceConfigOverwrite: {
          SHOW_PROMOTIONAL_CLOSE_PAGE: false,
          // HIDE_DEEP_LINKING_LOGO: true,
          // SHOW_BRAND_WATERMARK: false,
          LANG_DETECTION: true,
          // SHOW_JITSI_WATERMARK: false,
          // SHOW_WATERMARK_FOR_GUESTS: false,
          SHOW_CHROME_EXTENSION_BANNER: false,
          TOOLBAR_BUTTONS: [
            'microphone',
            'camera',
            'closedcaptions',
            'desktop',
            'fullscreen',
            'fodeviceselection',
            'hangup',
            'profile',
            'chat',
            'settings',
            'filmstrip',
            'invite',
            'shortcuts',
            'tileview',
            'download',
            'mute-everyone'
          ]
        }
        // Make sure to include a JWT if you intend to record,
        // make outbound calls or use any other premium features!
        // jwt: 'eyJraWQiOiJ2cGFhcy1tYWdpYy1jb29raWUtOWZlZjEyOGRiNTQyNDgzOThmN2Q0MDVjYjEwZTUwMWIvOWFjZGNjLVNBTVBMRV9BUFAiLCJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiJqaXRzaSIsImlzcyI6ImNoYXQiLCJpYXQiOjE2ODc4OTE0MDUsImV4cCI6MTY4Nzg5ODYwNSwibmJmIjoxNjg3ODkxNDAwLCJzdWIiOiJ2cGFhcy1tYWdpYy1jb29raWUtOWZlZjEyOGRiNTQyNDgzOThmN2Q0MDVjYjEwZTUwMWIiLCJjb250ZXh0Ijp7ImZlYXR1cmVzIjp7ImxpdmVzdHJlYW1pbmciOnRydWUsIm91dGJvdW5kLWNhbGwiOnRydWUsInNpcC1vdXRib3VuZC1jYWxsIjpmYWxzZSwidHJhbnNjcmlwdGlvbiI6dHJ1ZSwicmVjb3JkaW5nIjp0cnVlfSwidXNlciI6eyJoaWRkZW4tZnJvbS1yZWNvcmRlciI6ZmFsc2UsIm1vZGVyYXRvciI6dHJ1ZSwibmFtZSI6IndpbGxpYW0uY29lbGhvIiwiaWQiOiJnb29nbGUtb2F1dGgyfDExODE4NzM1MTA2MzM2OTkxMDc2OCIsImF2YXRhciI6IiIsImVtYWlsIjoid2lsbGlhbS5jb2VsaG9AcXVpY2tpbi5pbyJ9fSwicm9vbSI6IioifQ.Gp_gkBZR03G067HaKdgBNlyIIdqeppw3aOctPtgRxcZIt8XXiIYjQWZQwn5WVIlaYtQZuauGk9fpIU8woi6PKIXA6BoGKyORFwUUFQevLlAZ6EyiHdPkea7Kfst5z9_qhMyJJoEAxdr3FlNsCSepFfeK9vFFvSE8wRMgFEGQKFIjQNrBGPjIm9gVRiX-xWL55cSg0JhQoCjCIfmL_1vCSWXEbog5CGQqTlycCJba7Z74MtGUqjyKt2St44ss32kPsoHL37NTNQtUx90lTvTLJqRED4pNPxFgxV1EONObpWESRSVXnuZWnGzOip1VVVbVjUzFcys1tZdy4WtM2wlN-A'
      })
    },
    getContext () {
      const token = cookie.get('access_token')
      const headers = { Authorization: `Bearer ${token}` }
      return axiosInstance.get(`/meet-context/${this.token}`, { headers }).then(context => {
        const {
          candidate_id: candidateId,
          job_id: jobId,
          account_id: accountId
        } = context.data
        // verificar se tem acesso à vaga
        return axiosInstance.get(`/accounts/${accountId}/jobs/${jobId}`, { headers }).then(() => {
          return {
            candidateId,
            jobId,
            accountId
          }
        })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .iframe { height: 100%; }
</style>



// WEBPACK FOOTER //
// src/components/Meet/Meet.vue